import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';
import { FC, ReactNode } from 'react';

interface SearchableResultsLayoutProps extends React.HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
}

const SearchableResultsLayout: FC<SearchableResultsLayoutProps> & {
  FiltersWrapper: FC<React.HTMLAttributes<HTMLDivElement>>;
  ContentWrapper: FC<React.PropsWithChildren>;
} = ({ children, ...props }: SearchableResultsLayoutProps) => {
  return (
    <Container
      maxWidth="xl"
      sx={{
        pt: {
          xs: 2,
          md: 3,
        },
        px: {
          xs: 0,
        },
      }}
      {...props}
    >
      <Stack direction={{ xs: 'column', md: 'row' }} spacing={4}>
        {children}
      </Stack>
    </Container>
  );
};

const FiltersWrapper: FC<React.HTMLAttributes<HTMLDivElement>> = (props) => (
  <Stack sx={{ width: '100%', maxWidth: { md: '320px' } }} spacing={4} {...props} />
);

const ContentWrapper: FC<React.PropsWithChildren> = ({ children }) => (
  <Box flex={1}>
    <Stack spacing={4}>{children}</Stack>
  </Box>
);

SearchableResultsLayout.FiltersWrapper = FiltersWrapper;
SearchableResultsLayout.ContentWrapper = ContentWrapper;

export { SearchableResultsLayout };
